module.exports = {
  url: '/careers',
  template: require('raw!templates/careers/careers.html'),
  controller: CareersController,
  controllerAs: 'careersCtrl'
}

function CareersController($scope, $state, store, contentful, $uibModal, $window, NgMap, $http, emailSvc) {
  var vm = this;
  $window.scrollTo(0,0);
  $scope.page = 'careers'
  contentful.entries('content_type=careersPage').then(function(res) {
    $scope.contentfulData = res.data.items[0];
    // console.log('data', $scope.contentfulData);
  })
  contentful.entries('content_type=careersPage').then(function(res) {
    var seoData = res.data.items[0];
    if (seoData.fields.pageTitleSeo) {
      document.title = seoData.fields.pageTitleSeo;
    }
    if (seoData.fields.pageSpecificMetaDescriptionSeo) {
      var meta = document.getElementsByTagName("meta");
      for (var i = 0; i < meta.length; i++) {
        if (meta[i].name.toLowerCase() === "description") {
          meta[i].content = seoData.fields.pageSpecificMetaDescriptionSeo;
        }
      }
    }
  });
}



/** WEBPACK FOOTER **
 ** ./components/templates/careers/careers.js
 **/